import { FinancialGroup } from '@/app/models/financalGroup';
import { createContext, Dispatch, SetStateAction, useContext, useMemo, useState } from 'react';

interface FinancialGroupContextType {
  selectedFinancialGroup: FinancialGroup | undefined;
  setSelectedFinancialGroup: Dispatch<SetStateAction<FinancialGroup | undefined>>;
}

const FinancialGroupContext = createContext<FinancialGroupContextType | undefined>(undefined);

export function FinancialGroupProvider({ children }: { children: React.ReactNode }) {
  const [selectedFinancialGroup, setSelectedFinancialGroup] = useState<FinancialGroup | undefined>(undefined);
  const contextValue = useMemo(() => ({ selectedFinancialGroup, setSelectedFinancialGroup }), [selectedFinancialGroup]);

  return <FinancialGroupContext.Provider value={contextValue}>{children}</FinancialGroupContext.Provider>;
}

export const useFinancialGroup = () => {
  const context = useContext(FinancialGroupContext);
  if (!context) {
    throw new Error('useFinancialGroup deve ser usado dentro de um FinancialGroupContextProvider');
  }
  return context;
};
